import { EventEmitter } from '@angular/core';

export interface TranslationChangeEvent {
  lang: string;
  translations: any;
}

export interface LangChangeEvent {
  lang: string;
  translations: any;
}

export interface DefaultLangChangeEvent {
  lang: string;
  translations: any;
}

export class TranslateStore {
  defaultLang!: string;
  currentLang: string = this.defaultLang;
  translations: { [lang: string]: any } = {};
  langs: string[] = [];
  onTranslationChange: EventEmitter<TranslationChangeEvent> =
    new EventEmitter<TranslationChangeEvent>();
  onLangChange: EventEmitter<LangChangeEvent> = new EventEmitter<LangChangeEvent>();
  onDefaultLangChange: EventEmitter<DefaultLangChangeEvent> =
    new EventEmitter<DefaultLangChangeEvent>();
}
